import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ShoppingBag, Menu, X } from 'lucide-react';
import Button from '../Components/ui/Button';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 60) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const services = [
    { name: "Massage Therapy", path: "../massage-therapy" },
    { name: "Academy", path: "../academy" }
  ];

  return (
    <nav className={`fixed w-full h-1/8 z-50 top-0 left-0 transition-all duration-300 ${
      isScrolled ? 'bg-white border-b border-gray-200' : 'bg-transparent'
    }`}>
      <div className="max-w-screen-xl flex flex-wrap items-center justify-between md:justify-around mx-auto p-4">
        {/* Site Logo */}
        <Link to="../" className="flex items-center">
          <img
            src={'/static/images//logo.png'}
            alt="Piel Perfecta Logo"
            className={`h-12 md:h-16 w-auto transition-opacity duration-300 ${
              isScrolled ? 'opacity-100' : 'opacity-90'
            }`}
          />
          {/* Optional: Keep text alongside logo for accessibility or branding */}
          <span className="sr-only">Piel Perfecta</span>
        </Link>
        
        {/* Mobile View Menu Icon */}
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="md:hidden inline-flex text-dim bg-secondary rounded-full drop-shadow-sm items-center p-2 text-dim hover:bg-secondary-light hover:text-dim-dark rounded-lg"
        >
          {isOpen ? <X size={24} /> : <Menu size={24} />}
        </button>

        <div className={`${isOpen ? 'block' : 'hidden'} bg-gray-100 w-full rounded-b-2xl md:bg-transparent md:flex md:items-center md:w-auto md:-mr-40`}>
          <ul className={`font-medium flex flex-col md:flex-row md:items-center md:space-x-12 md:space-y-0 space-y-4 mt-4 md:mt-0 ${
            isScrolled ? 'md:bg-transparent' : 'md:bg-secondary md:rounded-full'
          } p-4 md:py-2 md:px-6`}>
            <li>
              <Link to="../" className="block text-gray-900 hover:text-pink-600">
                Home
              </Link>
            </li>
            <li>
              <Link to="../about" className="block text-gray-900 hover:text-pink-600">
                About
              </Link>
            </li>
            <li className="relative">
              <button
                onClick={() => setIsServicesOpen(!isServicesOpen)}
                className="flex items-center w-full text-gray-900 hover:text-pink-600"
              >
                Services
                <svg 
                  className={`w-4 h-4 ml-1 transition-transform ${isServicesOpen ? 'rotate-180' : ''}`} 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              {isServicesOpen && (
                <div className="md:absolute relative left-0 mt-2 w-48 bg-white rounded-md shadow-lg py-2">
                  {services.map((service, index) => (
                    <Link 
                      key={index}
                      to={service.path}
                      className="block px-4 py-2 text-gray-800 hover:bg-pink-50 hover:text-pink-600"
                      onClick={() => {
                        setIsServicesOpen(false);
                        setIsOpen(false);
                      }}
                    >
                      {service.name}
                    </Link>
                  ))}
                </div>
              )}
            </li>
            <li>
              <Link to="../faq" className="block text-gray-900 hover:text-pink-600">
                FAQ
              </Link>
            </li>
            <li>
              <Link to="../ecommerce" className="flex items-center gap-2 text-gray-900 hover:text-pink-600">
                SHOP
                <ShoppingBag size={18}/>
              </Link>
            </li>
            <li className="md:hidden">
              <Button to="../booking" className="w-full">
                BOOK APPOINTMENT
              </Button>
            </li>
          </ul>
        </div>

        <div className="hidden md:block">
          <Button to="../booking">
            BOOK APPOINTMENT
          </Button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;